import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location.pathname]);

  return (
    <nav
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-8">
        <div className="flex items-center justify-between h-16 md:h-18">
          <Link
            to="/"
            className="flex items-center gap-2 whitespace-nowrap cursor-pointer"
          >
            <span className="text-2xl md:text-3xl font-black font-heading tracking-tight text-primary-500">
              91
            </span>
            <span className={`text-lg md:text-xl font-bold transition-colors duration-300 ${
              isScrolled ? 'text-foreground-950' : 'text-background-50'
            }`}>
              免费
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            {categories.map((cat) => (
              <Link
                key={cat.id}
                to={`/category/${cat.slug}`}
                className={`whitespace-nowrap px-3 py-2 rounded-lg text-sm font-medium transition-all duration-200 cursor-pointer ${
                  location.pathname === `/category/${cat.slug}`
                    ? 'bg-primary-500 text-background-50'
                    : isScrolled
                    ? 'text-foreground-700 hover:text-primary-500 hover:bg-primary-50'
                    : 'text-background-50/90 hover:text-background-50 hover:bg-background-50/15'
                }`}
              >
                {cat.name}
              </Link>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-3">
            <Link
              to="/about"
              className={`whitespace-nowrap text-sm font-medium transition-colors duration-200 cursor-pointer ${
                isScrolled ? 'text-foreground-600 hover:text-primary-500' : 'text-background-50/80 hover:text-background-50'
              }`}
            >
              关于我们
            </Link>
            <a
              href="/category/daily-update"
              className="whitespace-nowrap px-5 py-2 bg-primary-500 text-background-50 text-sm font-semibold rounded-full transition-all duration-200 hover:bg-primary-600 cursor-pointer"
            >
              每日更新
            </a>
          </div>

          <button
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg cursor-pointer"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            aria-label="菜单"
          >
            <i className={`text-xl ${isScrolled ? 'text-foreground-950' : 'text-background-50'} ${
              isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'
            }`}></i>
          </button>
        </div>
      </div>

      {isMobileMenuOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200">
          <div className="px-4 py-4 flex flex-col gap-1">
            {categories.map((cat) => (
              <Link
                key={cat.id}
                to={`/category/${cat.slug}`}
                className={`flex items-center gap-3 px-3 py-3 rounded-lg text-sm font-medium transition-all duration-200 cursor-pointer ${
                  location.pathname === `/category/${cat.slug}`
                    ? 'bg-primary-100 text-primary-700'
                    : 'text-foreground-700 hover:bg-background-100'
                }`}
              >
                <span className="w-8 h-8 flex items-center justify-center">
                  <i className={`${cat.icon} text-lg`}></i>
                </span>
                {cat.name}
              </Link>
            ))}
            <div className="border-t border-background-200 my-2"></div>
            <Link
              to="/about"
              className="flex items-center gap-3 px-3 py-3 rounded-lg text-sm font-medium text-foreground-700 hover:bg-background-100 transition-all cursor-pointer"
            >
              <span className="w-8 h-8 flex items-center justify-center">
                <i className="ri-information-line text-lg"></i>
              </span>
              关于我们
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}